<template>
    <div class="mb-4">
        <h3>{{ distributor.name }}</h3>
        <bs5-base-button variant="success" class="mb-3" @click="showAddClientModal = true">
            <i class="bi bi-plus-lg"></i> Add Client
        </bs5-base-button>
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead class="table-dark">
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(client, index) in clients" :key="client.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ client.name }}</td>
                        <td>{{ client.description }}</td>
                        <td>
                            <bs5-group-button>
                                <bs5-edit-button @click="editClient(client.id)" />
                                <bs5-base-button variant="warning" @click="openGenerateLicenseModal(client.id)">
                                    Generate License
                                </bs5-base-button>
                                <bs5-base-button variant="info" @click="openViewLicensesModal(client.id)">
                                    View Licenses
                                </bs5-base-button>
                                <bs5-delete-button @click="deleteClient(client.id)" />
                            </bs5-group-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- Modal Dodawania Klienta -->
        <AddClientModal :visible="showAddClientModal" :distributorId="distributor.id"
            @close="() => { showAddClientModal = false; selectedClientId = '' }" @client-added="fetchClients" />

        <!-- Modal Edycji Klienta -->
        <EditClientModal :visible="showEditClientModal" :clientId="selectedClientId"
            @close="() => { showEditClientModal = false; selectedClientId = '' }" @client-updated="fetchClients" />

        <!-- Modal Generowania Licencji -->
        <GenerateLicenseModal :visible="showGenerateLicenseModal" :clientId="selectedClientId"
            @close="() => { showGenerateLicenseModal = false; selectedClientId = '' }"
            @license-generated="fetchClients" />

        <!-- Modal Licencji Klienta -->
        <ClientLicensesModal :visible="showViewLicensesModal" :clientId="selectedClientId"
            @close="() => { showViewLicensesModal = false; selectedClientId = '' }" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import AddClientModal from "@/views/clients/modals/AddClientModal.vue"
import EditClientModal from "@/views/clients/modals/EditClientModal.vue"
import GenerateLicenseModal from "@/views/licenses/modals/GenerateLicenseModal.vue"
import ClientLicensesModal from "@/views/clients/modals/ClientLicensesModal.vue"
import clientService from "@/services/client.service";
import { Client } from "@/models/client.model";
import { showToast } from "@/utils/toast";

export default defineComponent({
    name: "ClientList",
    components: { AddClientModal, EditClientModal, GenerateLicenseModal, ClientLicensesModal },
    props: {
        distributor: { type: Object, required: true },
    },
    data() {
        return {
            clients: ref<Client[]>([]),
            showAddClientModal: ref(false),
            showEditClientModal: ref(false),
            showGenerateLicenseModal: ref(false),
            showViewLicensesModal: ref(false),
            selectedClientId: ref<string>(""),
        };
    },
    methods: {
        async fetchClients() {
            try {
                this.clients = await clientService.getClientsByDistributor(this.distributor.id);
            } catch (error) {
                console.error("Error fetching clients:", error);
            }
        },
        editClient(clientId: string | null | undefined) {
            this.selectedClientId = clientId as string;
            this.showEditClientModal = true;
        },
        async deleteClient(clientId: string | null | undefined) {
            try {
                const response = await this.$swal.fire({
                    title: "Are you sure?",
                    text: "This action cannot be undone!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "Cancel",
                });

                if (response.isConfirmed) {
                    try {
                        await clientService.deleteClient(clientId as string);
                        showToast("The client has been removed.", "success");
                        this.fetchClients();
                    } catch (error) {
                        showToast("Failed to delete client.", "error");
                        console.error("Error deleting client:", error);
                    }
                }
            }
            catch (e) {
                console.log(e);
            }
        },
        openGenerateLicenseModal(clientId: string | null | undefined) {
            this.selectedClientId = clientId as string;
            this.showGenerateLicenseModal = true;
        },
        openViewLicensesModal(clientId: string | null | undefined) {
            this.selectedClientId = clientId as string;
            this.showViewLicensesModal = true;
        },
    },
    mounted() {
        this.fetchClients();
    },
});
</script>